import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { connectionBus } from '../../utils/connectionBus';

const ApiConnectionAlert: React.FC = () => {
  const [refused, setRefused] = useState<boolean>(false);

  useEffect(() => {
    const unsubscribe = connectionBus.subscribe(setRefused);
    return unsubscribe;
  }, []);

  if (!refused) return null;

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      Não foi possível se conectar com o servidor da aplicação neste momento. Por favor, tente mais tarde.
    </Alert>
  );
};

export default ApiConnectionAlert;